import { generateClient } from "aws-amplify/api";
const client = generateClient();

import { list_audit_logs } from "@/graphql/queries";

export default {
  data() {
    return {
      auditLogsList: [],
      auditLogsNextToken: null,
      auditLogsLimit: 100,
    };
  },

  methods: {
    async fetchAuditLogs({
      organization_id,
      from_date,
      to_date,
      log_action,
      keywords,
      next_token = null,
      append = false,
    }) {
      try {
        const response = await client.graphql({
          query: list_audit_logs,
          variables: {
            input: {
              organization_id,
              from_date,
              to_date,
              log_action,
              keywords,
              next_token,
              limit: this.auditLogsLimit,
            },
          },
        });

        const responseData = JSON.parse(response.data.list_audit_logs);

        if (responseData.status === "SUCCESS") {
          const rows = responseData.data || [];

          this.auditLogsList = append
            ? [...this.auditLogsList, ...rows]
            : rows;

          this.auditLogsNextToken = responseData.next_token || null;
        } else {
          if (!append) this.auditLogsList = [];
          this.auditLogsNextToken = null;
        }
      } catch (error) {
        console.error("Error fetching audit logs:", error);

        if (error == "NoValidAuthTokens: No federated jwt") {
          this.$router.push("/login");
          this.$store.dispatch("logout");
          this.$store.dispatch("clearAuth");
          this.$store.dispatch("clearUser");
          this.$store.dispatch("clearToken");
          this.$store.dispatch("clearRefreshToken");
          this.$store.dispatch("clearExpiresAt");
          this.$store.dispatch("clearExpiresIn");
        }

        if (!append) this.auditLogsList = [];
        this.auditLogsNextToken = null;
        throw error;
      }
    },

    async fetchNextAuditLogs({ organization_id, from_date, to_date, log_action }) {
      if (!this.auditLogsNextToken) return;

      await this.fetchAuditLogs({
        organization_id,
        from_date,
        to_date,
        log_action,
        next_token: this.auditLogsNextToken,
        append: true,
      });
    },
  },
};